(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-flavors-bis"] && !Shopify.designMode) return;
  try {
    
  class MpFlavorsBis extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mpg__track');
      this.dots = this.querySelector('.mpg__dots');
      if (!this.track || !this.dots) return;
      this.cartes = [...this.track.querySelectorAll('.mpg__card')];
      if (!this.cartes.length) return;

      // Boucle : une copie du jeu de saveurs avant et une après. On saute d'un
      // tour entier dès qu'on sort du jeu du milieu, sans que ça se voie.
      this.avant = this.cartes.map((c) => this.cloner(c));
      this.apres = this.cartes.map((c) => this.cloner(c));
      this.avant.reverse().forEach((c) => this.track.prepend(c));
      this.apres.forEach((c) => this.track.append(c));

      this.construire();
      this.track.addEventListener('scroll', () => this.auScroll(), { passive: true });
      if ('onscrollend' in window) {
        this.track.addEventListener('scrollend', () => this.recentrer(), { passive: true });
      }
      window.addEventListener('resize', () => this.construire(), { passive: true });
    }

    cloner(carte) {
      const c = carte.cloneNode(true);
      c.classList.add('mpg__card--clone');
      c.setAttribute('aria-hidden', 'true');
      c.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
      return c;
    }

    get tour() {
      const premier = this.cartes[0];
      const suivant = this.cartes[1] || premier;
      const pas = this.cartes.length > 1 ? suivant.offsetLeft - premier.offsetLeft : premier.offsetWidth;
      return pas * this.cartes.length;
    }

    get grille() {
      return this.classList.contains('mpg--grille') && window.matchMedia('(min-width: 750px)').matches;
    }

    construire() {
      const defile = !this.grille && this.track.scrollWidth > this.track.clientWidth + 4;
      this.classList.toggle('mpg--no-scroll', !defile);
      this.classList.toggle('mpg--boucle', defile);

      if (this.dots.childElementCount !== this.cartes.length) {
        this.dots.innerHTML = '';
        this.cartes.forEach((carte, i) => {
          const point = document.createElement('button');
          point.type = 'button';
          point.className = 'mpg__dot';
          point.setAttribute('aria-label', 'Saveur ' + (i + 1));
          point.addEventListener('click', () => this.aller(i));
          this.dots.appendChild(point);
        });
      }

      if (defile) {
        this.track.scrollLeft = this.cible(this.cartes[0]);
      }
      this.marquer();
    }

    aller(i) {
      const carte = this.cartes[i];
      this.track.scrollTo({ left: this.cible(carte), behavior: 'smooth' });
    }

    cible(carte) {
      const centre = window.matchMedia('(max-width: 749px)').matches;
      if (centre) {
        return carte.offsetLeft - (this.track.clientWidth - carte.offsetWidth) / 2;
      }
      const marge = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
      return carte.offsetLeft - marge;
    }

    auScroll() {
      if (this.grille) return;
      this.marquer();
      if (!this.classList.contains('mpg--boucle')) return;
      // Le recentrage attend la fin du geste : fait pendant l'inertie, il
      // coupait le défilement en plein milieu du jeu de saveurs.
      clearTimeout(this.minuteur);
      this.minuteur = setTimeout(() => this.recentrer(), 140);
    }

    recentrer() {
      const tour = this.tour;
      const basse = this.cible(this.cartes[0]);
      const haute = this.cible(this.cartes[this.cartes.length - 1]);
      const x = this.track.scrollLeft;
      // On ne saute qu'une fois entré dans les copies, jamais entre deux saveurs.
      if (x < basse - 2) {
        this.sauter(tour);
      } else if (x > haute + 2) {
        this.sauter(-tour);
      }
    }

    sauter(delta) {
      const avant = this.track.style.scrollBehavior;
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft += delta;
      this.track.style.scrollBehavior = avant;
    }

    marquer() {
      const centre = this.track.scrollLeft + this.track.clientWidth / 2;
      const toutes = [...this.track.querySelectorAll('.mpg__card')];
      let actif = 0;
      let ecart = Infinity;
      toutes.forEach((carte, i) => {
        const d = Math.abs(carte.offsetLeft + carte.offsetWidth / 2 - centre);
        if (d < ecart) { ecart = d; actif = i; }
      });
      const n = this.cartes.length;
      const index = ((actif % n) + n) % n;
      [...this.dots.children].forEach((p, i) => p.classList.toggle('is-active', i === index));
    }
  }

  if (!customElements.get('mp-flavors-bis')) {
    customElements.define('mp-flavors-bis', MpFlavorsBis);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-flavors-x"] && !Shopify.designMode) return;
  try {
    
  class MpFlavorsX extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mpx__track');
      this.dots = this.querySelector('.mpx__dots');
      if (!this.track || !this.dots) return;
      this.cartes = [...this.track.querySelectorAll('.mpx__card')];
      if (!this.cartes.length) return;

      // Boucle : une copie du jeu de saveurs avant et une après. On saute d'un
      // tour entier dès qu'on sort du jeu du milieu, sans que ça se voie.
      this.avant = this.cartes.map((c) => this.cloner(c));
      this.apres = this.cartes.map((c) => this.cloner(c));
      this.avant.reverse().forEach((c) => this.track.prepend(c));
      this.apres.forEach((c) => this.track.append(c));

      this.construire();
      this.track.addEventListener('scroll', () => this.auScroll(), { passive: true });
      if ('onscrollend' in window) {
        this.track.addEventListener('scrollend', () => this.recentrer(), { passive: true });
      }
      window.addEventListener('resize', () => this.construire(), { passive: true });
    }

    cloner(carte) {
      const c = carte.cloneNode(true);
      c.classList.add('mpx__card--clone');
      c.setAttribute('aria-hidden', 'true');
      c.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
      return c;
    }

    get tour() {
      const premier = this.cartes[0];
      const suivant = this.cartes[1] || premier;
      const pas = this.cartes.length > 1 ? suivant.offsetLeft - premier.offsetLeft : premier.offsetWidth;
      return pas * this.cartes.length;
    }

    get grille() {
      return this.classList.contains('mpx--grille') && window.matchMedia('(min-width: 750px)').matches;
    }

    construire() {
      const defile = !this.grille && this.track.scrollWidth > this.track.clientWidth + 4;
      this.classList.toggle('mpx--no-scroll', !defile);
      this.classList.toggle('mpx--boucle', defile);

      if (this.dots.childElementCount !== this.cartes.length) {
        this.dots.innerHTML = '';
        this.cartes.forEach((carte, i) => {
          const point = document.createElement('button');
          point.type = 'button';
          point.className = 'mpx__dot';
          point.setAttribute('aria-label', 'Saveur ' + (i + 1));
          point.addEventListener('click', () => this.aller(i));
          this.dots.appendChild(point);
        });
      }

      if (defile) {
        this.track.scrollLeft = this.cible(this.cartes[0]);
      }
      this.marquer();
    }

    aller(i) {
      const carte = this.cartes[i];
      this.track.scrollTo({ left: this.cible(carte), behavior: 'smooth' });
    }

    cible(carte) {
      const centre = window.matchMedia('(max-width: 749px)').matches;
      if (centre) {
        return carte.offsetLeft - (this.track.clientWidth - carte.offsetWidth) / 2;
      }
      const marge = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
      return carte.offsetLeft - marge;
    }

    auScroll() {
      if (this.grille) return;
      this.marquer();
      if (!this.classList.contains('mpx--boucle')) return;
      // Le recentrage attend la fin du geste : fait pendant l'inertie, il
      // coupait le défilement en plein milieu du jeu de saveurs.
      clearTimeout(this.minuteur);
      this.minuteur = setTimeout(() => this.recentrer(), 140);
    }

    recentrer() {
      const tour = this.tour;
      const basse = this.cible(this.cartes[0]);
      const haute = this.cible(this.cartes[this.cartes.length - 1]);
      const x = this.track.scrollLeft;
      // On ne saute qu'une fois entré dans les copies, jamais entre deux saveurs.
      if (x < basse - 2) {
        this.sauter(tour);
      } else if (x > haute + 2) {
        this.sauter(-tour);
      }
    }

    sauter(delta) {
      const avant = this.track.style.scrollBehavior;
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft += delta;
      this.track.style.scrollBehavior = avant;
    }

    marquer() {
      const centre = this.track.scrollLeft + this.track.clientWidth / 2;
      const toutes = [...this.track.querySelectorAll('.mpx__card')];
      let actif = 0;
      let ecart = Infinity;
      toutes.forEach((carte, i) => {
        const d = Math.abs(carte.offsetLeft + carte.offsetWidth / 2 - centre);
        if (d < ecart) { ecart = d; actif = i; }
      });
      const n = this.cartes.length;
      const index = ((actif % n) + n) % n;
      [...this.dots.children].forEach((p, i) => p.classList.toggle('is-active', i === index));
    }
  }

  if (!customElements.get('mp-flavors-x')) {
    customElements.define('mp-flavors-x', MpFlavorsX);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-flavors"] && !Shopify.designMode) return;
  try {
    
  class MpFlavors extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mpf__track');
      this.dots = this.querySelector('.mpf__dots');
      if (!this.track || !this.dots) return;
      this.cartes = [...this.track.querySelectorAll('.mpf__card')];
      if (!this.cartes.length) return;

      // Boucle : une copie du jeu de saveurs avant et une après. On saute d'un
      // tour entier dès qu'on sort du jeu du milieu, sans que ça se voie.
      this.avant = this.cartes.map((c) => this.cloner(c));
      this.apres = this.cartes.map((c) => this.cloner(c));
      this.avant.reverse().forEach((c) => this.track.prepend(c));
      this.apres.forEach((c) => this.track.append(c));

      this.prec = this.querySelector('.mpf__fleche--prec');
      this.suiv = this.querySelector('.mpf__fleche--suiv');
      if (this.prec) this.prec.addEventListener('click', () => this.pas(-1));
      if (this.suiv) this.suiv.addEventListener('click', () => this.pas(1));
      this.glisser();

      this.construire();
      this.track.addEventListener('scroll', () => this.auScroll(), { passive: true });
      if ('onscrollend' in window) {
        this.track.addEventListener('scrollend', () => this.recentrer(), { passive: true });
      }
      window.addEventListener('resize', () => this.construire(), { passive: true });
    }

    cloner(carte) {
      const c = carte.cloneNode(true);
      c.classList.add('mpf__card--clone');
      c.setAttribute('aria-hidden', 'true');
      c.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
      return c;
    }

    get tour() {
      const premier = this.cartes[0];
      const suivant = this.cartes[1] || premier;
      const pas = this.cartes.length > 1 ? suivant.offsetLeft - premier.offsetLeft : premier.offsetWidth;
      return pas * this.cartes.length;
    }

    get grille() {
      return this.classList.contains('mpf--grille') && window.matchMedia('(min-width: 750px)').matches;
    }

    get mobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    construire() {
      const defile = !this.grille && this.track.scrollWidth > this.track.clientWidth + 4;
      // La boucle sans fin n'a de sens que sur mobile, où l'on voit une saveur
      // à la fois. Sur ordinateur le rail s'arrête à la dernière saveur, comme
      // les carrousels d'Horizon.
      const boucle = defile && this.mobile;
      this.classList.toggle('mpf--no-scroll', !defile);
      this.classList.toggle('mpf--boucle', boucle);

      if (this.dots.childElementCount !== this.cartes.length) {
        this.dots.innerHTML = '';
        this.cartes.forEach((carte, i) => {
          const point = document.createElement('button');
          point.type = 'button';
          point.className = 'mpf__dot';
          point.setAttribute('aria-label', 'Saveur ' + (i + 1));
          point.addEventListener('click', () => this.aller(i));
          this.dots.appendChild(point);
        });
      }

      if (defile) {
        this.track.scrollLeft = boucle ? this.cible(this.cartes[0]) : 0;
      }
      this.marquer();
      this.fleches();
    }

    aller(i) {
      const carte = this.cartes[i];
      this.track.scrollTo({ left: this.cible(carte), behavior: 'smooth' });
    }

    // Une flèche avance d'une carte, dans le sens de lecture.
    pas(sens) {
      const toutes = [...this.track.querySelectorAll('.mpf__card')].filter((c) => c.offsetParent !== null);
      if (!toutes.length) return;
      const marge = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
      const x = this.track.scrollLeft + marge;
      let cible = null;
      if (sens > 0) {
        cible = toutes.find((c) => c.offsetLeft > x + 4);
      } else {
        const avant = toutes.filter((c) => c.offsetLeft < x - 4);
        cible = avant[avant.length - 1];
      }
      if (!cible) return;
      this.track.scrollTo({ left: cible.offsetLeft - marge, behavior: 'smooth' });
    }

    // Glisser-déposer à la souris : le rail se traîne comme sur mobile.
    glisser() {
      let actif = false;
      let departX = 0;
      let departScroll = 0;
      let bouge = 0;

      this.track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || this.grille) return;
        if (e.target.closest('a, button')) return;
        actif = true;
        bouge = 0;
        departX = e.clientX;
        departScroll = this.track.scrollLeft;
        this.track.style.scrollSnapType = 'none';
        this.classList.add('mpf--glisse');
      });

      this.track.addEventListener('pointermove', (e) => {
        if (!actif) return;
        const dx = e.clientX - departX;
        if (Math.abs(dx) > bouge) bouge = Math.abs(dx);
        if (bouge > 3) {
          this.track.setPointerCapture(e.pointerId);
          this.track.scrollLeft = departScroll - dx;
        }
      });

      const fin = () => {
        if (!actif) return;
        actif = false;
        this.track.style.scrollSnapType = '';
        this.classList.remove('mpf--glisse');
      };

      this.track.addEventListener('pointerup', fin);
      this.track.addEventListener('pointercancel', fin);
      this.track.addEventListener('pointerleave', fin);

      // Un glissé ne doit pas déclencher le lien de la carte relâchée dessous.
      this.track.addEventListener('click', (e) => {
        if (bouge > 6) {
          e.preventDefault();
          e.stopPropagation();
          bouge = 0;
        }
      }, true);
    }

    fleches() {
      if (!this.prec && !this.suiv) return;
      const enBoucle = this.classList.contains('mpf--boucle');
      const max = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      if (this.prec) this.prec.disabled = !enBoucle && x <= 2;
      if (this.suiv) this.suiv.disabled = !enBoucle && x >= max - 2;
    }

    cible(carte) {
      const centre = window.matchMedia('(max-width: 749px)').matches;
      if (centre) {
        return carte.offsetLeft - (this.track.clientWidth - carte.offsetWidth) / 2;
      }
      const marge = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
      return carte.offsetLeft - marge;
    }

    auScroll() {
      if (this.grille) return;
      this.marquer();
      this.fleches();
      if (!this.classList.contains('mpf--boucle')) return;
      // Le recentrage attend la fin du geste : fait pendant l'inertie, il
      // coupait le défilement en plein milieu du jeu de saveurs.
      clearTimeout(this.minuteur);
      this.minuteur = setTimeout(() => this.recentrer(), 140);
    }

    recentrer() {
      if (!this.classList.contains('mpf--boucle')) return;
      const tour = this.tour;
      const basse = this.cible(this.cartes[0]);
      const haute = this.cible(this.cartes[this.cartes.length - 1]);
      const x = this.track.scrollLeft;
      // On ne saute qu'une fois entré dans les copies, jamais entre deux saveurs.
      if (x < basse - 2) {
        this.sauter(tour);
      } else if (x > haute + 2) {
        this.sauter(-tour);
      }
    }

    sauter(delta) {
      const avant = this.track.style.scrollBehavior;
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft += delta;
      this.track.style.scrollBehavior = avant;
    }

    marquer() {
      const enBoucle = this.classList.contains('mpf--boucle');
      const centre = enBoucle
        ? this.track.scrollLeft + this.track.clientWidth / 2
        : this.track.scrollLeft + this.cartes[0].offsetWidth / 2;
      const toutes = [...this.track.querySelectorAll('.mpf__card')];
      let actif = 0;
      let ecart = Infinity;
      toutes.forEach((carte, i) => {
        const d = Math.abs(carte.offsetLeft + carte.offsetWidth / 2 - centre);
        if (d < ecart) { ecart = d; actif = i; }
      });
      const n = this.cartes.length;
      const index = ((actif % n) + n) % n;
      [...this.dots.children].forEach((p, i) => p.classList.toggle('is-active', i === index));
    }
  }

  if (!customElements.get('mp-flavors')) {
    customElements.define('mp-flavors', MpFlavors);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-recipes"] && !Shopify.designMode) return;
  try {
    
  class MpRecipes extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mprec__track');
      this.dots = this.querySelector('.mprec__dots');
      if (!this.track || !this.dots) return;
      this.cartes = [...this.track.querySelectorAll('.mprec__card')];
      if (!this.cartes.length) return;

      // Boucle, exactement comme le carrousel des saveurs : un jeu complet de
      // copies avant et un après, et on saute d'un tour quand on sort du jeu du
      // milieu. Le saut se fait ainsi loin des bords du rail — une seule copie de
      // chaque côté plaçait le saut tout au bout, là où Safari iOS applique son
      // rebond et son magnétisme, et le passage dernière → première accrochait.
      // Les copies ne coûtent rien : leurs vidéos ne se chargent qu'à l'écran.
      this.jumeau = new Map();
      if (this.cartes.length > 1) {
        const avant = this.cartes.map((c) => this.cloner(c));
        const apres = this.cartes.map((c) => this.cloner(c));
        this.cartes.forEach((c, i) => { this.jumeau.set(avant[i], c); this.jumeau.set(apres[i], c); });
        avant.slice().reverse().forEach((c) => this.track.prepend(c));
        apres.forEach((c) => this.track.append(c));
      }

      this.prec = this.querySelector('.mprec__fleche--prec');
      this.suiv = this.querySelector('.mprec__fleche--suiv');
      if (this.prec) this.prec.addEventListener('click', () => this.pas(-1));
      if (this.suiv) this.suiv.addEventListener('click', () => this.pas(1));
      this.glisser();

      this.veiller();

      this.construire();
      this.track.addEventListener('scroll', () => this.auScroll(), { passive: true });
      if ('onscrollend' in window) {
        this.track.addEventListener('scrollend', () => this.recentrer(), { passive: true });
      }
      // Sur iPhone, la barre d'adresse qui se replie pendant le défilement de la
      // page déclenche 'resize' en continu : on ne reconstruit que si la largeur
      // change vraiment, sinon le rail revenait sans cesse à la première recette.
      let largeur = window.innerWidth;
      window.addEventListener('resize', () => {
        if (window.innerWidth === largeur) return;
        largeur = window.innerWidth;
        this.construire();
      }, { passive: true });
    }

    // Lecture des vidéos : une seule règle, recalculée à chaque mouvement du
    // rail ou de la page. (Plusieurs observateurs indépendants se contredisaient
    // selon l'ordre de leurs notifications : une vidéo relancée était coupée.)
    //  - Mobile : seule la carte du centre joue. Ses voisines, sur les bords,
    //    attendent à l'arrêt mais déjà chargées : elles démarrent à l'instant où
    //    le swipe les amène au centre, sans temps de chargement.
    //  - Ordinateur : toutes les cartes visibles jouent.
    // Quand la carte du centre est une copie de boucle, sa vraie carte joue
    // aussi, cachée et au même instant, pour que le saut ne se voie pas.
    veiller() {
      const lire = this.dataset.autoplay === '1';
      const enAttente = new Set();
      let sectionEnVue = false;

      const essayer = (v) => {
        const essai = v.play();
        if (!essai || !essai.then) return;
        essai.then(() => enAttente.delete(v)).catch(() => {
          v.addEventListener('loadeddata', () => { if (enAttente.has(v)) essayer(v); }, { once: true });
        });
      };

      const jouer = (v) => {
        if (v.preload !== 'auto') v.preload = 'auto';
        if (!lire || !v.paused) return;
        // Safari iOS n'accepte la lecture automatique que d'une vidéo muette et
        // intégrée à la page : on le pose en propriété, pas seulement en attribut.
        v.muted = true;
        v.defaultMuted = true;
        v.playsInline = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        enAttente.add(v);
        essayer(v);
      };

      const arreter = (v) => {
        enAttente.delete(v);
        if (!v.paused) v.pause();
      };

      // Précharger une vidéo à l'arrêt. Safari iOS ignore « preload » et ne
      // charge rien tant qu'on ne lance pas la lecture : on la lance donc le temps
      // qu'elle ait de quoi jouer, et on l'arrête aussitôt.
      let aJouer = new Set();
      const chauffer = (v) => {
        if (v.preload !== 'auto') v.preload = 'auto';
        if (!lire || v.readyState >= 3 || v.dataset.chauffe) return;
        v.dataset.chauffe = '1';
        v.muted = true;
        v.playsInline = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        const essai = v.play();
        if (essai && essai.then) {
          essai.then(() => { if (!aJouer.has(v)) v.pause(); }).catch(() => { delete v.dataset.chauffe; });
        }
      };

      // la vraie carte suit sa copie : même instant
      const caler = (copie, vraie) => {
        if (vraie.readyState > 0 && copie.readyState > 0 && Math.abs(vraie.currentTime - copie.currentTime) > 0.3) {
          try { vraie.currentTime = copie.currentTime; } catch (e) {}
        }
      };

      const regler = () => {
        const toutes = [...this.track.querySelectorAll('.mprec__card')];
        const boite = this.track.getBoundingClientRect();
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const milieu = boite.left + boite.width / 2;
        const aChauffer = new Set();
        aJouer = new Set();

        const ajouter = (c) => {
          const v = c.querySelector('video');
          if (!v) return;
          aJouer.add(v);
          const vraie = this.jumeau.get(c);
          const w = vraie && vraie.querySelector('video');
          if (w) { caler(v, w); aJouer.add(w); }
        };

        if (sectionEnVue) {
          toutes.forEach((c) => {
            if (c.offsetParent === null) return;
            const r = c.getBoundingClientRect();
            if (r.right <= boite.left + 1 || r.left >= boite.right - 1) return;
            if (!mobile) { ajouter(c); return; }
            // la carte qui recouvre le milieu du rail joue, les autres attendent
            if (r.left <= milieu && milieu < r.right) ajouter(c);
            else { const v = c.querySelector('video'); if (v) aChauffer.add(v); }
          });
        }

        toutes.forEach((c) => {
          const v = c.querySelector('video');
          if (!v) return;
          if (aJouer.has(v)) jouer(v);
          else {
            if (lire) arreter(v);
            if (aChauffer.has(v)) chauffer(v);
          }
        });
      };

      let prevu = false;
      const planifier = () => {
        if (prevu) return;
        prevu = true;
        requestAnimationFrame(() => { prevu = false; regler(); });
      };

      // La section entre ou sort de l'écran ; on précharge un peu avant.
      new IntersectionObserver((entrees) => {
        entrees.forEach((e) => { sectionEnVue = e.isIntersecting; });
        planifier();
      }, { threshold: 0 }).observe(this.track);

      new IntersectionObserver((entrees) => {
        entrees.forEach((e) => {
          if (!e.isIntersecting) return;
          this.track.querySelectorAll('.mprec__card').forEach((c) => {
            const r = c.getBoundingClientRect();
            const b = this.track.getBoundingClientRect();
            const v = c.querySelector('video');
            if (v && r.right > b.left && r.left < b.right && v.preload === 'none') v.preload = 'auto';
          });
        });
      }, { rootMargin: '250px 0px', threshold: 0 }).observe(this.track);

      this.track.addEventListener('scroll', planifier, { passive: true });

      // Un toucher, même pour faire défiler la page, autorise la lecture sur iOS
      // (et en mode économie d'énergie) : on relance alors ce qui attendait.
      const relancer = () => { enAttente.forEach((v) => essayer(v)); planifier(); };
      ['touchend', 'click', 'keydown'].forEach((t) => document.addEventListener(t, relancer, { passive: true }));

      this.lecteur = { regler, caler };
    }

    cloner(carte) {
      const c = carte.cloneNode(true);
      c.classList.add('mprec__card--clone');
      c.setAttribute('aria-hidden', 'true');
      c.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
      return c;
    }

    get mobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    get tour() {
      const pas = this.cartes.length > 1
        ? this.cartes[1].offsetLeft - this.cartes[0].offsetLeft
        : this.cartes[0].offsetWidth;
      return pas * this.cartes.length;
    }

    construire() {
      const defile = this.track.scrollWidth > this.track.clientWidth + 4;
      // La boucle n'a de sens que sur mobile, où l'on voit une recette à la fois.
      const boucle = defile && this.mobile && this.cartes.length > 1;
      this.classList.toggle('mprec--no-scroll', !defile);
      this.classList.toggle('mprec--boucle', boucle);

      if (this.dots.childElementCount !== this.cartes.length) {
        this.dots.innerHTML = '';
        this.cartes.forEach((carte, i) => {
          const point = document.createElement('button');
          point.type = 'button';
          point.className = 'mprec__dot';
          point.setAttribute('aria-label', 'Recette ' + (i + 1));
          point.addEventListener('click', () => this.aller(i));
          this.dots.appendChild(point);
        });
      }

      if (defile) {
        this.track.scrollLeft = boucle ? this.cible(this.cartes[0]) : 0;
      }
      this.marquer();
      this.fleches();
    }

    cible(carte) {
      const centre = window.matchMedia('(max-width: 749px)').matches;
      if (centre) {
        return carte.offsetLeft - (this.track.clientWidth - carte.offsetWidth) / 2;
      }
      const marge = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
      return carte.offsetLeft - marge;
    }

    aller(i) {
      this.track.scrollTo({ left: this.cible(this.cartes[i]), behavior: 'smooth' });
    }

    // Une flèche avance d'une carte, dans le sens de lecture.
    pas(sens) {
      const marge = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
      const x = this.track.scrollLeft + marge;
      let carte = null;
      if (sens > 0) {
        carte = this.cartes.find((c) => c.offsetLeft > x + 4);
      } else {
        const avant = this.cartes.filter((c) => c.offsetLeft < x - 4);
        carte = avant[avant.length - 1];
      }
      if (!carte) return;
      this.track.scrollTo({ left: carte.offsetLeft - marge, behavior: 'smooth' });
    }

    // Glisser-déposer à la souris : le rail se traîne comme sur mobile.
    glisser() {
      let actif = false;
      let departX = 0;
      let departScroll = 0;
      let bouge = 0;

      this.track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        if (e.target.closest('a, button, video[controls]')) return;
        actif = true;
        bouge = 0;
        departX = e.clientX;
        departScroll = this.track.scrollLeft;
        this.track.style.scrollSnapType = 'none';
        this.classList.add('mprec--glisse');
      });

      this.track.addEventListener('pointermove', (e) => {
        if (!actif) return;
        const dx = e.clientX - departX;
        if (Math.abs(dx) > bouge) bouge = Math.abs(dx);
        if (bouge > 3) {
          this.track.setPointerCapture(e.pointerId);
          this.track.scrollLeft = departScroll - dx;
        }
      });

      const fin = () => {
        if (!actif) return;
        actif = false;
        this.track.style.scrollSnapType = '';
        this.classList.remove('mprec--glisse');
      };

      this.track.addEventListener('pointerup', fin);
      this.track.addEventListener('pointercancel', fin);
      this.track.addEventListener('pointerleave', fin);

      this.track.addEventListener('click', (e) => {
        if (bouge > 6) {
          e.preventDefault();
          e.stopPropagation();
          bouge = 0;
        }
      }, true);
    }

    fleches() {
      if (!this.prec && !this.suiv) return;
      const enBoucle = this.classList.contains('mprec--boucle');
      const max = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      if (this.prec) this.prec.disabled = !enBoucle && x <= 2;
      if (this.suiv) this.suiv.disabled = !enBoucle && x >= max - 2;
    }

    auScroll() {
      this.marquer();
      this.fleches();
      if (!this.classList.contains('mprec--boucle')) return;
      // Le saut attend la fin du geste : fait pendant l'inertie, il couperait
      // le défilement en plein milieu.
      clearTimeout(this.minuteur);
      this.minuteur = setTimeout(() => this.recentrer(), 140);
    }

    recentrer() {
      if (!this.classList.contains('mprec--boucle')) return;
      const tour = this.tour;
      const basse = this.cible(this.cartes[0]);
      const haute = this.cible(this.cartes[this.cartes.length - 1]);
      const x = this.track.scrollLeft;
      // On ne saute qu'une fois entré dans les copies, jamais entre deux recettes.
      if (x < basse - 2) this.sauter(tour);
      else if (x > haute + 2) this.sauter(-tour);
    }

    // Même saut que le carrousel saveurs. En plus : la carte au centre est une
    // copie, sa vraie carte (celle qu'on va retrouver après le saut) doit
    // tourner au même instant, pour que la vidéo ne reparte pas d'ailleurs.
    sauter(delta) {
      const cx = this.track.scrollLeft + this.track.clientWidth / 2;
      const auCentre = [...this.track.querySelectorAll('.mprec__card')].find((c) => c.offsetLeft <= cx && cx < c.offsetLeft + c.offsetWidth);
      const vraie = auCentre && this.jumeau.get(auCentre);
      const a = auCentre && auCentre.querySelector('video');
      const b = vraie && vraie.querySelector('video');
      if (a && b && this.lecteur) this.lecteur.caler(a, b);

      const avant = this.track.style.scrollBehavior;
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft += delta;
      this.track.style.scrollBehavior = avant;
      if (this.lecteur) this.lecteur.regler();
    }

    marquer() {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const repere = mobile
        ? this.track.scrollLeft + this.track.clientWidth / 2
        : this.track.scrollLeft + this.cartes[0].offsetWidth / 2;
      const toutes = [...this.track.querySelectorAll('.mprec__card')].filter((c) => c.offsetParent !== null);
      let actif = 0;
      let ecart = Infinity;
      toutes.forEach((carte, i) => {
        const d = Math.abs(carte.offsetLeft + carte.offsetWidth / 2 - repere);
        if (d < ecart) { ecart = d; actif = i; }
      });
      const n = this.cartes.length;
      const reel = this.jumeau.get(toutes[actif]) || toutes[actif];
      const index = Math.max(0, this.cartes.indexOf(reel)) % n;
      [...this.dots.children].forEach((p, i) => p.classList.toggle('is-active', i === index));
    }
  }

  if (!customElements.get('mp-recipes')) {
    customElements.define('mp-recipes', MpRecipes);
  }

  } catch(e) { console.error(e); }
})();
})();
